// extracted by mini-css-extract-plugin
export default {"root":"vU8ThF6n5oIXRXAvZtQF"};